@let optionsValue = options();
@let controls = contents().controls;

<rt-box
  variant="background-light no-border no-padding"
  layout-vertical
  margin-top-small-x
  padding-tb-small
  padding-lr
>
  @for (option of optionsValue; track $index; let i = $index; let last = $last) {
    <div
      class="scorecard-field__aspect"
      [attr.data-evaluation-invalid]="controls[i].invalid ? '' : null"
    >
      <div class="scorecard-field__aspect-title">
        {{ option.title }}
        @if (required()) {
          <span
            class="scorecard-field__asterisk"
            [class.scorecard-field__asterisk--hidden]="!controls[i].invalid"
            >*</span
          >
        }
      </div>
      @if (option.hint) {
        <div class="scorecard-field__aspect-hint">{{ option.hint }}</div>
      }

      <rt-evaluation-rating-buttons [control]="controls[i]" margin-top-small-x />
    </div>
    @if (!last) {
      <rt-divider variant="line light" margin-tb-small />
    }
  }
</rt-box>
